// here, the index maps to the error code returned from getValidationError - see readme
const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

function validatePhoneNumber(phone){
    
    if(!phone.isValidNumber()){
        var errorCode = phone.getValidationError();
        if (errorCode == -99){
            return errorMap[0];
        }else{
            return errorMap[errorCode];
        }
    }
    return true;
}

export default validatePhoneNumber;